import { BreadcrumbProps } from "@/types/component"
import ArrowRight from "@/components/icons/arrowRight"

import "./index.scss"

import React from "react"

const Breadcrumb: React.FC<BreadcrumbProps> = ({ 
  items, 
  separator = <ArrowRight height={16} width={16} />, 
  className = "" 
}) => {
  return (
    <nav className={`breadcrumb ${className}`} aria-label="breadcrumb">
      <ol className="breadcrumb__list">
        {items.map((item, index) => {
          const isLast = index === items.length - 1

          return (
            <li key={index} className="breadcrumb__item">
              {!isLast && (item.href || item.onClick) ? (
                <>
                  {item.href ? (
                    <a 
                      href={item.href} 
                      className="breadcrumb__link"
                    >
                      {item.label}
                    </a>
                  ) : (
                    <button
                      onClick={item.onClick}
                      className="breadcrumb__link breadcrumb__link--button"
                    >
                      {item.label}
                    </button>
                  )}
                  <span className="breadcrumb__separator">{separator}</span>
                </>
              ) : (
                <span className={`breadcrumb__text ${isLast ? "breadcrumb__text--active" : ""}`}>
                  {item.label}
                </span>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}

export default Breadcrumb

